import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import '@/styles/brand-pages.css';

const PressPage = () => {
  return (
    <div className="brand-page press-page" data-testid="press-page">
      <div className="brand-page__inner">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <Link to="/" className="brand-page__back">← Back</Link>
        </motion.div>

        <motion.h1 
          className="brand-page__headline"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          Press
        </motion.h1>

        <div className="brand-page__content">
          <motion.p 
            className="brand-page__body"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.8 }}
          >
            NYMPHÉ is a curated connection platform designed around intention, presence, and a more refined experience of attraction.
          </motion.p>

          <motion.div 
            className="brand-page__contact"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
          >
            <p className="brand-page__contact-label">For press and media enquiries:</p>
            <a href="mailto:press@nymphe.app" className="brand-page__email">
              press@nymphe.app
            </a>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default PressPage;
